<template>
  <div style="padding: 8px; width:100% ;height: calc(100vh - 140px); overflow-y: auto;overflow-x: hidden;">
    <div style="display: flex; align-items: center">
      <div style="flex: 1">
        <el-tabs v-model="activeTab" @tab-click="handleClick" class="tabs">
          <el-tab-pane :label="$t('fuelEfficientDriving.综合看板')" name="infoBoards" >
            <infoBoards :cpnName="cpnName"/>
          </el-tab-pane>
          <el-tab-pane :label="$t('fuelEfficientDriving.趋势分析')" name="trend">
            <trend :cpnName="cpnName" />
          </el-tab-pane>
          <el-tab-pane :label="$t('fuelEfficientDriving.车辆明细')" name="carDetail">
            <carDetail :cpnName="cpnName" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import infoBoards from "@/views/driver/fuel_efficient_driving/info_boards/index";
import trend from "@/views/driver/fuel_efficient_driving/trend/index";
import carDetail from "@/views/driver/fuel_efficient_driving/car_detail/index";
export default {
  components: { infoBoards, trend, carDetail },
  data() {
    return {
      activeTab: "infoBoards",
      cpnName:undefined,
    };
  },
  methods: {
    getcpnName() {
      this.$api
        .headOfficeSearch({
          companyID: this.$store.getters.operator.CompanyId,
        })
        .then((res) => {
          this.cpnName = res.headOfficeInfo.corporateName;
        });
    },
    // tab点击事件
    handleClick(tabs) {
      this.$nextTick(function () {
        var myEvent = new Event("resize");
        window.dispatchEvent(myEvent);
      });
      const { index } = tabs;
      // console.log(index);
      switch (index) {
        case "0":
          break;
        case "1":
          // this.dayInit = true;
          break;
      }
    },
  },
  mounted(){
    this.getcpnName();
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  ::v-deep .el-tabs__header {
    margin: 0;
  }
  ::v-deep .el-tabs__active-bar {
    height: 3px;
    border-radius: 2px;
  }
}
</style>